module.exports = __webpack_public_path__ + "static/media/IncidentReport.54a5e1ee.svg";